/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {Oktoberfest} from "../Oktoberfest";

export class OktoberfestNormalIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        flowStateController.setSkipCallback(() => this.skip(flowStateController))

        Oktoberfest.reels.forEach((reel) => {
            reel.reelState = ReelState.IDLE;
        });

        if(Oktoberfest.model.gameData?.nextMode != GameMode.NORMAL) {
            flowStateController.finish();
            return;
        }

        //Because the tombstonerip has Gamble enabled, you wont see any win toggeling. It was decided during BookOfShadow that no toggeling should happen if there was gamble involved.
        //Though if you play the game with Norsktipping or Germany jurisdiction it will function as normal because at the moment ow writing this Gamble is not allowed in those jurisdictions.
        if(!Oktoberfest.isActionSpinsActive){
            Oktoberfest.individualWin.start();
        }
    }

    private async skip(flowStateController:FlowStateController):Promise<any> {
        await Oktoberfest.individualWin.stop();
        flowStateController.finish();
    }
}